var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stopwatch-container", on: { click: _vm.onTouch } },
    [
      _c("div", { staticClass: "stopwatch-time-container" }, [
        _c("button", {
          staticClass: "reset-timer",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.onOpenResetStopwatch.apply(null, arguments)
            },
          },
        }),
        _c("div", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.formatStopwatchTime)),
        ]),
        _c("button", {
          staticClass: "stop-timer",
          class: { active: this.stopwatchState === "pause" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggleStopwatch.apply(null, arguments)
            },
          },
        }),
      ]),
      _c("div", { staticClass: "detail-timer-info" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.studyInfoSetting?.todayStudyTime,
                expression: "studyInfoSetting?.todayStudyTime",
              },
            ],
            staticClass: "detail-container total",
          },
          [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("camstudy.stopwatch.todayStudyTime"))),
            ]),
            _c("div", { staticClass: "detail-content" }, [
              _vm._v(_vm._s(_vm.formatTodayStudyTime)),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.studyInfoSetting?.targetStudyTime,
                expression: "studyInfoSetting?.targetStudyTime",
              },
            ],
            staticClass: "detail-container target",
          },
          [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("camstudy.stopwatch.targetStudyTime"))),
            ]),
            _c("div", { staticClass: "detail-content" }, [
              _vm._v(_vm._s(_vm.formatTargetStudyTime)),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.studyInfoSetting?.totalStudyTime,
                expression: "studyInfoSetting?.totalStudyTime",
              },
            ],
            staticClass: "detail-container total",
          },
          [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("camstudy.stopwatch.totalStudyTime"))),
            ]),
            _c("div", { staticClass: "detail-content" }, [
              _vm._v(_vm._s(_vm.formatTotalStudyTime)),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.studyInfoSetting?.remainDays,
                expression: "studyInfoSetting?.remainDays",
              },
            ],
            staticClass: "detail-container",
          },
          [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("camstudy.stopwatch.myDDay"))),
            ]),
            _c("div", { staticClass: "detail-content" }, [
              _vm._v(_vm._s(_vm.formatDDayTime)),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.studyInfoSetting?.studyDays,
                expression: "studyInfoSetting?.studyDays",
              },
            ],
            staticClass: "detail-container",
          },
          [
            _c("div", { staticClass: "detail-title" }, [
              _vm._v(_vm._s(_vm.$t("camstudy.stopwatch.studyPeriod"))),
            ]),
            _c("div", { staticClass: "detail-content" }, [
              _vm._v(_vm._s(_vm.formatStudyRemainTime)),
            ]),
          ]
        ),
      ]),
      _vm.isOpenStopWatchOption
        ? _c("GrmCamstudyOptionModal", {
            attrs: {
              title: _vm.$t("camstudy.stopwatch.options.reset.selectTitle"),
              list: _vm.stopWatchResetType,
              name: "stop-watch-reset-type",
              value: "timer-reset",
            },
            on: {
              onCloseOption: _vm.onCloseStopWatchResetType,
              onNextAct: _vm.onReqResetStopWatch,
            },
          })
        : _vm._e(),
      _vm.isOpenAttendOption
        ? _c("GrmCamstudyOptionModal", {
            attrs: {
              title: _vm.$t(
                "camstudy.stopwatch.options.attendance.selectTitle"
              ),
              list: _vm.attendCheckType,
              name: "attend-check-type",
              value: "attend",
            },
            on: {
              onCloseOption: _vm.onCloseAttendOption,
              onNextAct: _vm.onReqAttendOption,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }